import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskText, FadeUp } from "./MaskText";
import { useLocale } from "@/i18n/LocaleContext";

export const About = () => {
  const { t } = useLocale();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="about" ref={ref} className="relative border-t border-white/10 py-24 md:py-32" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 md:gap-20 items-center">
        <div>
          <FadeUp>
            <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-nowi-muted">{t.about.kicker}</span>
          </FadeUp>
          <MaskText
            lines={t.about.heading}
            className="mt-5 font-playfair text-4xl md:text-6xl leading-[0.95] tracking-[-0.02em]"
          />
          <FadeUp delay={0.1}>
            <p className="mt-8 text-nowi-muted text-base max-w-md">{t.about.p1}</p>
            <p className="mt-5 text-nowi-muted text-base max-w-md">{t.about.p2}</p>
          </FadeUp>
          <FadeUp delay={0.2}>
            <div className="mt-10 flex gap-10">
              {t.about.stats.map(([n, l]) => (
                <div key={l}>
                  <div className="font-playfair text-3xl">{n}</div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-nowi-muted mt-1">{l}</div>
                </div>
              ))}
            </div>
          </FadeUp>
        </div>

        <div className="relative h-[420px] md:h-[560px] overflow-hidden border border-white/10" data-testid="about-locale-image">
          <motion.div style={{ y: imgY }} className="absolute inset-[-12%]">
            <img src={t.about.localeImage} alt={t.about.localeCaption} className="w-full h-full object-cover grayscale" />
          </motion.div>
          <div className="absolute inset-0 bg-gradient-to-t from-nowi-bg/70 to-transparent" />
          <div className="absolute bottom-6 left-6 font-mono text-[11px] uppercase tracking-[0.2em] text-nowi-text">{t.about.localeCaption}</div>
        </div>
      </div>
    </section>
  );
};
